import axios from "axios";

export const state = {
  cached: "",
};

export const getters = {};

export const mutations = {};

export const actions = {
  async getNotification({ commit, state, rootState }, { queryValue }) {
    if (queryValue && queryValue.length > 0) {
      return axios
        .get(`/cmn/notification/filter${queryValue}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async updateSeen({ commit, state, rootState }, { pathValue, seen }) {
    if (pathValue) {
      return axios
        .put(`/cmn/notification/update/seen/${pathValue}`, {
          seen,
        })
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async countNotification({ commit, state, rootState }, { queryValue }) {
    if (queryValue && queryValue.length > 0) {
      return axios
        .get(`/cmn/notification/count${queryValue}`)
        .then((response) => {
          if (response.data != null && response.data.object != null) {
            return response.data.object;
          }
          return null;
        })
        .catch(function () {
          return null;
        });
    }
    return Promise.resolve(null);
  },

  async unseenNotificationList({ commit, state, rootState }, { userAddress }) {
    return axios
      .post(`/ztx/multisig/notification/unseen`, {
        userAddress,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data.object;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async updateMultipleSeen({ commit, state, rootState }, { id, seen }) {
    return axios
      .post(`/cmn/notification/update/seen`, {
        id,
        seen,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data.object;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },

  async updateAllSeen({ commit, state, rootState }, { userAddress, seen }) {
    return axios
      .post(`/cmn/notification/update/seen/all`, {
        userAddress,
        seen,
      })
      .then((response) => {
        if (response.data != null && response.data.object != null) {
          return response.data.object;
        }
        return null;
      })
      .catch(function (error) {
        return error;
      });
  },
};


